// @flow

import React from "react";
import { localize } from "redux-i18n";
import {
  Button,
  ButtonGroup,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Row,
  Col,
} from "@components";

type OwnProps = $Exact<{
  enabled: boolean,
  onDismissHandler: () => void,
  onSubmit: (status: boolean) => void,
}>;

type Props = $Exact<{
  ...OwnProps,
  ...PropsFromLocalize,
}>;

type ComponentState = $Exact<{
  enabled: boolean,
}>;

export class EditAccountDetailslModal extends React.Component<Props, ComponentState> {
  constructor(props: Props) {
    super(props);

    this.state = {
      enabled: props.enabled,
    };
  }

  componentDidUpdate(prevProps: Props) {
    if (prevProps.enabled !== this.props.enabled) {
      this.setState({
        enabled: this.props.enabled,
      });
    }
  }

  handleButtonClick = (status: boolean) => () => {
    this.setState({
      enabled: status,
    });
  };

  handleSubmit = () => {
    this.props.onSubmit(this.state.enabled);
  };

  render() {
    return (
      <Modal className="modal-small">
        <ModalHeader toggle={this.props.onDismissHandler}>
          {this.props.t("ACCOUNT_DETAILS")}
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col sm={{ size: 8, offset: 2 }}>
              <label>{this.props.t("ACCOUNT_STATUS")}</label>
              <ButtonGroup fillSpace>
                <Button
                  color={this.state.enabled ? "selected" : null}
                  onClick={this.handleButtonClick(true)}
                >
                  {this.props.t("ENABLED")}
                </Button>
                <Button
                  color={this.state.enabled ? null : "selected"}
                  onClick={this.handleButtonClick(false)}
                >
                  {this.props.t("DISABLED")}
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button onClick={this.props.onDismissHandler} color="secondary">
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="save" onClick={this.handleSubmit}>
            {this.props.t("SAVE")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(EditAccountDetailslModal);
